import React from 'react';
import Provider from 'react-redux/es/components/Provider';
import store from './store';
import Page from './pages/page';
import Mobile from './pages/mobile';
import { StylesProvider,createGenerateClassName } from '@material-ui/core/styles';
import { isMobile } from 'react-device-detect';


const generateClassName = createGenerateClassName({
  seed: 'design-system'
});

function App() {

  return (
   
   <StylesProvider  injectFirst generateClassName={generateClassName}>
      <Provider store={store}>
        {isMobile ? <Mobile/> : <Page/>} 
      </Provider>
   </StylesProvider> 
 
    
  );
}

export default App;

